module.exports = __webpack_public_path__ + "static/media/комната гг 5.39acf567.jpg";